module.exports = __webpack_public_path__ + "static/media/bytt-no-12.5bf51ce8.mp3";